module.exports = __webpack_public_path__ + "static/img/Matt-Crouch.2cefba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Crouch.jpg
// module id = X07M
// module chunks = 0